import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackTrialClick } from "@/lib/analytics";

const SCROLL_THRESHOLD = 600;

/**
 * StickyCTABar - A slim sticky bar that appears after scrolling
 * Shows a single focused CTA to keep conversion visible during content consumption
 */
export default function StickyCTABar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_THRESHOLD);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    trackTrialClick("sticky_cta_bar");
  };

  return (
    <div
      className={`fixed left-0 right-0 z-40 transition-all duration-300 ${
        isVisible 
          ? "translate-y-0 opacity-100" 
          : "-translate-y-full opacity-0 pointer-events-none"
      }`}
      style={{ top: "var(--banner-offset, 0px)" }}
    >
      <div className="bg-ch-hero/95 backdrop-blur-md border-b border-white/10 shadow-lg">
        <div className="container">
          <div className="flex items-center justify-between h-12 gap-4">
            {/* Left: Value prop */}
            <p className="text-white/90 text-sm font-medium hidden sm:block truncate">
              Get audit-ready with ComplyHub — No credit card required
            </p>
            <p className="text-white/90 text-xs font-medium sm:hidden truncate">
              Get audit-ready today
            </p>

            {/* Right: CTA */}
            <Button
              size="sm"
              className="bg-ch-cyan text-white hover:bg-ch-cyan/90 font-semibold text-sm px-4 h-8 rounded-full flex-shrink-0"
              asChild
            >
              <a
                href="/trial-signup"
                onClick={handleClick}
              >
                <span className="hidden sm:inline">Start Free Trial</span>
                <span className="sm:hidden">Free Trial</span>
                <ArrowRight className="ml-1.5 w-3.5 h-3.5" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
